module.exports = __webpack_public_path__ + "static/media/CE logo.e14fa912.png";